<template>
	<div v-if="data" class="content">
		<p v-text="content" />
		<p>
			<button class="button is-primary" @click.prevent="downloadableContent">
				Download {{ data.title }}
			</button>
		</p>
	</div>
</template>

<script>
import format from "date-fns/format";
import FileSaver from "file-saver";
import { exportDownloadableContent } from "@lab/api";

export default {
	props: {
		data: {
			type: Object,
			default: () => null
		}
	},
	computed: {
		content() {
			return this.data.content;
		},
		source() {
			return this.data.source;
		}
	},
	methods: {
		async downloadableContent() {
			try {
				// 1. call the api call for exporting org users
				const csv = await exportDownloadableContent(this.source);

				// 2. create the filename for downloading
				const name = `freshness-score`;
				const date = format(new Date(), "DDMMYYYY_HHmmss");
				const filename = `${name}-users-${date}.csv`;

				const csvFile = new Blob([csv], { type: "text/csv;charset=utf-8" });

				FileSaver.saveAs(csvFile, filename);
			} catch (error) {
				// Just rethrowing error for the moment.
				// will set isFetching to be false here though
				console.log(error);
				throw error;
			}
			// console.log(context);
		}
	}
};
</script>

<style scoped></style>
